export enum MarketingCampaignStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PAUSED = 'PAUSED',
  DECLINED = 'DECLINED',
}

export enum BudgetType {
  DAILY = 'daily',
  LIFETIME = 'lifetime',
}
